import { render, staticRenderFns } from "./DownloadOrders.vue?vue&type=template&id=1f76660e"
import script from "./DownloadOrders.vue?vue&type=script&lang=ts"
export * from "./DownloadOrders.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports